import VisitsController, {
  UserInfoModel,
  VisitModel,
} from '../controllers/VisitsController';
import CrudActionContainer from './CrudActionContainer';

class VisitsCRUDActions extends CrudActionContainer {
  retrieveData: string;

  constructor() {
    super('VISITS');
  }

  async getVisits(visitorId: string): Promise<VisitModel[]> {
    try {
      const response = await VisitsController.getVisits(visitorId);
      return response;
    } catch (e) {
      return [];
    }
  }

  async getUserInfo(
    visitorId: string,
    utmCampaign: string,
  ): Promise<UserInfoModel> {
    try {
      if (!visitorId) {
        return { name: '', email: '' };
      }

      const response = await VisitsController.getUserInfo(
        visitorId,
        utmCampaign,
      );
      return response;
    } catch (e) {
      return { name: '', email: '' };
    }
  }
}

const visitsCRUDActions = new VisitsCRUDActions();

export default visitsCRUDActions;
